import { Button, Table, Tag, Modal } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import { loadSingleLeaveHistory } from "../../redux/rtk/features/leave/leaveSlice";
import getPermissions from "../../utils/getPermissions";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import getUserFromToken from "../../utils/getUserFromToken";
import BtnViewSvg from "../UI/Button/btnViewSvg";
import AddLeave from "./AddLeave";
import { EditOutlined } from '@ant-design/icons';

function CustomTable({ list, loading, refetch }) {
  const [columnsToShow, setColumnsToShow] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [leaveDrawerOpen, setLeaveDrawerOpen] = useState(false);
  const permissions = getPermissions();

  const hasPermission = (item) => {
    return permissions?.includes(item ? item : "");
  };

  const showEditModal = (record) => {
    setSelectedLeave(record);
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setSelectedLeave(null);
  };

  const columns = [
    {
      id: 1,
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
    },
    {
      id: 3,
      title: "Leave Type",
      dataIndex: "leaveType",
      key: "leaveType",
      render: (leaveType) => leaveType || "N/A",
    },
    {
      id: 4,
      title: "Leave From",
      dataIndex: "leaveFrom",
      key: "leaveFrom",
      render: (leaveFrom) => {
        if (typeof leaveFrom === "string" && leaveFrom.includes("|")) {
          const [date, type] = leaveFrom.split("|");
          return `${dayjs(date).format("YYYY-MM-DD")} (${type})`;
        }
        return dayjs(leaveFrom).format("YYYY-MM-DD");
      },
    },
    {
      id: 5,
      title: "Leave To",
      dataIndex: "leaveTo",
      key: "leaveTo",
      render: (leaveTo) => {
        if (typeof leaveTo === "string" && leaveTo.includes("|")) {
          const [date, type] = leaveTo.split("|");
          return `${dayjs(date).format("YYYY-MM-DD")} (${type})`;
        }
        return dayjs(leaveTo).format("YYYY-MM-DD");
      },
    },
    {
      id: 6,
      title: "Leave Duration",
      dataIndex: "totalleaveDays",
      key: "totalleaveDays",
      render: (totalleaveDays) => {
        if (totalleaveDays > 0) {
          return <span>{totalleaveDays} days</span>;
        } else {
          return <span>{totalleaveDays} day</span>;
        }
      },
    },
    {
      id: 7,
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        if (status === "ACCEPTED") {
          return <Tag color="green">{status}</Tag>;
        } else if (status === "REJECTED") {
          return <Tag color="red">{status}</Tag>;
        } else {
          return <Tag color="orange">{status}</Tag>;
        }
      },
    },
    {
      id: 8,
      title: "Action",
      key: "action",
      render: (record) => (
        <div className="flex gap-2">
          {/* {hasPermission("update-leaveApplication") && ( */}
            <>
              {/* <ViewBtn
                path={`/admin/leave/${record.id}`}
                text="View"
                icon={<BtnViewSvg />}
              /> */}
              {/* Only show edit button if status is not "APPROVED" or "REJECTED" */}
              {record.status !== "APPROVED" && record.status !== "REJECTED" && (
                <button
                  onClick={() => showEditModal(record)}
                  className="text-blue-600 hover:text-blue-800"
                  title="Edit"
                >
                  <EditOutlined />
                </button>
              )}
            </>
          {/* )} */}
        </div>
      ),
    },
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  const addKeys = (arr) =>
    arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

  return (
    <div className="user-leave-page-container">
      <div className="ant-card p-4 rounded mt-5 user-leave-card">
        <div className="flex my-2 justify-between user-leave-header">
          <div className="w-50">
            <h4 className="text-2xl mb-2">My Leave Applications</h4>
          </div>
          <div className="flex gap-2 items-center">
            <Button type="primary" onClick={() => setLeaveDrawerOpen(true)}>
              Apply for Leave
            </Button>
            {list?.length > 0 && (
              <div className="mt-0.5">
                <CsvLinkBtn>
                  <CSVLink
                    data={list}
                    className="btn btn-dark btn-sm"
                    style={{ marginTop: "5px" }}
                    filename="leave_applications"
                  >
                    Download CSV
                  </CSVLink>
                </CsvLinkBtn>
              </div>
            )}
          </div>
        </div>
        <div className="user-leave-actions" style={{ marginBottom: "30px" }}>
          <ColVisibilityDropdown
            options={columns}
            columns={columns}
            columnsToShowHandler={columnsToShowHandler}
          />
        </div>
        <Table
          className="text-center"
          scroll={{ x: true, y: "100%" }}
          loading={loading}
          columns={columnsToShow}
          dataSource={list ? addKeys(list) : []}
        />
      </div>
      <Modal
        title="Edit Leave Application"
        open={isModalVisible}
        onCancel={handleModalCancel}
        footer={null}
        width={600}
      >
        <AddLeave
          initialValues={selectedLeave}
          onCancel={handleModalCancel}
        />
      </Modal>
      <Modal
        title="Apply for Leave"
        open={leaveDrawerOpen}
        onCancel={() => setLeaveDrawerOpen(false)}
        footer={null}
        width={520}
        destroyOnClose
      >
        <AddLeave
          onCancel={() => {
            setLeaveDrawerOpen(false);
            refetch?.();
          }}
        />
      </Modal>
    </div>
  );
}

const UserLeave = () => {
  const EmployeeId = getUserFromToken();
  const dispatch = useDispatch();

  const list = useSelector((state) => state.leave?.leaveHistory) || [];
  const loading = useSelector((state) => state.leave?.loading) || false;

  // console.log("Redux state.leave:", useSelector((state) => state.leave));
  // console.log("list:", list);
  // console.log("loading:", loading);

  const transformedList = list.map((item) => ({
    id: item.EmployeeLeaveId,
    leaveType: item.LeaveTypeName,
    leaveTypeId: item.LeaveTypeId,
    leaveFrom: item.IsCustom
      ? `${item.StartDate}|${item.StartDateDayTypeName}`
      : item.StartDate,
    leaveTo: item.IsCustom
      ? `${item.EndDate}|${item.EndDateDayTypeName}`
      : item.EndDate,
    totalleaveDays: item.LeaveInDays,
    status: item.LeaveStatusName.toUpperCase(),
    isCustom: item.IsCustom,
    startDateDayTypeId: item.StartDateDayTypeId,
    endDateDayTypeId: item.EndDateDayTypeId,
  }));

  // console.log("transformedList:", transformedList);

  useEffect(() => {
    dispatch(loadSingleLeaveHistory(EmployeeId));
  }, [dispatch, EmployeeId]);

  const refetchList = () => {
    dispatch(loadSingleLeaveHistory(EmployeeId));
  };

  return (
    <div className="card">
      <div className="card-body">
        <CustomTable list={transformedList} loading={loading} refetch={refetchList} />
      </div>
    </div>
  );
};

export default UserLeave;